import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AxiosInstance } from "../../../../../axios";
import ViewInfo from "./CourseInfoCreate.module.css";
import { ImageUrlPrefix } from "../../../../../labels";
import Loader from "../../../Loader";
import fileDownload from "js-file-download";
import axios from "axios";
import ConfirmationPopup from "../../TestAdminWorkflow/Gallery/ConfirmationPopup/ConfirmationPopup";
import toast from "react-hot-toast";

export default function ViewCourseInfo() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { FCAT, FTYPE, FGROUPCOURSE, FSUBCATEGORY, FSEARCHTERM } =
    location.state || {};
  const [formFields, setFormFields] = useState({
    Category: "",
    GroupHeading: "",
    AdmissionType: "",
    CourseName: "",
    groupCourseName: "",
    content_path: null,
    content_path_original: null,
  });
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/course/courseview", { id: parseInt(id) })
      .then((res) => {
        if (res.data.status === true) {
          setFormFields({
            Category: res.data.data[0].category,
            GroupHeading: res.data.data[0].subcategory_code,
            AdmissionType: res.data.data[0].type,
            CourseName: res.data.data[0].course_name,
            groupCourseName: res.data.data[0].group_course_name,
            content_path: res.data.data[0].course_content_path,
            content_path_original:
              res.data.data[0].course_content_original_path,
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [id]);
  const navigateToPreviousScreen = () => {
    navigate("/CourseManagement/1", {
      state: {
        filType: FTYPE,
        filCateCode: FCAT,
        filSubCate: FSUBCATEGORY,
        filGroupCourse: FGROUPCOURSE,
        filSearch: FSEARCHTERM,
      },
    });
  };

  const handleNavigate = (idsss) => {
    navigate(`/editCourse/${idsss}`);
  };

  const handleDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${formFields.content_path}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };

  const handleDelete = () => {
    if (!id) {
      console.error("ID is missing");
      return;
    }

    AxiosInstance.post("api/course/delete/course", { id })
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          handleClose();
          navigate(-1);
        } else {
          toast.error(res.data.message || "Failed to delete course");
        }
      })
      .catch((error) => {
        console.error("Delete failed:", error);
        toast.error("Something went wrong while deleting.");
      });
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      {showModal && (
        <ConfirmationPopup
          open={showModal}
          title="Remove Course"
          message="Are you sure you want to remove this course?"
          onConfirm={handleDelete}
          onCancel={handleClose}
        />
      )}

      <div className={`${ViewInfo.CourseInfoSec} BathHeader global_container`}>
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">View Course</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  onClick={navigateToPreviousScreen}
                  to="javascript:void(0)"
                  className="secondaryButton "
                  variant="secondary"
                >
                  Back to Course Management
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  // onClick={() => handleNavigate(id)}
                  onClick={() => handleShow()}
                  className="primaryButton"
                  variant="primary"
                >
                  {" "}
                  {/* <span className="material-icons me-1 fs-5 align-middle text-white">
                    delete
                  </span> */}
                  Remove Course
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={() => handleNavigate(id)}
                  className="primaryButton"
                  variant="primary"
                >
                  {" "}
                  <span className="material-icons me-1 fs-5 align-middle text-white">
                    border_color
                  </span>{" "}
                  Edit Course
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Course Details</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Course</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.CourseName || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Type of Admission</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.AdmissionType === "" && "_"}
                    {formFields.AdmissionType === 0 && "Course"}
                    {formFields.AdmissionType === 1 && "Test Batch"}
                    {formFields.AdmissionType === 2 && "Counselling"}
                    {formFields.AdmissionType === 3 && "Special Class"}
                    {formFields.AdmissionType === 4 && "Model Exam"}
                    {formFields.AdmissionType === 5 && "Mock Interview"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Category</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.Category || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Course Group Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.groupCourseName || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Sub Category</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.GroupHeading || "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset className="mt-3">
            <legend className="w-auto">Course Content</legend>
            <div className="row ">
              <div className="my-1 col-md-12 ">
                <div className="">
                  <label className="confirm_label m-0 p-0">
                    Uploaded Course Content
                  </label>
                  {formFields.content_path !== null &&
                    formFields.content_path !== "" && (
                      // <button onClick={() => handleDownload(formFields.content_path, formFields.content_path_original)} >Download Image</button>
                      <a
                        to="javascript:void(0)"
                        onClick={() =>
                          handleDownload(
                            formFields.content_path,
                            formFields.content_path_original
                          )
                        }
                      >
                        <span
                          className={`${ViewInfo.mui_icon} material-icons   align-middle mx-1`}
                        >
                          file_download
                        </span>
                      </a>
                    )}
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.content_path_original
                      ? formFields.content_path_original
                      : "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </>
  );
}
